import { Link } from "react-router-dom";

export default function HomeFiveBlog(){
    return(
        <section id="news" class="blog-area blog-area-3 pt-115 pb-90 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30 home-5">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="section-title text-center mb-60">
							<p class="mb-10">Our Blog</p>
							<h2 class="sect-title">Latest News and Articles</h2>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-4 col-md-6">
						<div class="blogs mb-30">
							<div class="blogs__thumb">
								<Link to="/news-details">
									<img class="w-100" src="assets/img/home-5/1-768x409.jpg" alt="Blog Img" />
								</Link>
							</div>
							<div class="blogs__content">
								<p><i class="fal fa-calendar-alt"></i> June 21, 2022</p>
								<h5><Link class="blog-title" to="/news-details">Technology support
										allows erie non-profit to serve</Link></h5>
								<p class="text">A great commerce experience cannot be distilled to a single number. It’s
									not a
									Lighthouse score, or a set of...</p>
								<div class="btn-part">
                                <Link to="/news-details" class="readon-arrow">Read More <i class="fa fa fa-arrow-right"></i></Link>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6">
						<div class="blogs mb-30">
							<div class="blogs__thumb">
                            <Link to="/news-details">
									<img class="w-100" src="assets/img/home-5/2-768x409.jpg" alt="Blog Img" />
								</Link>
							</div>
							<div class="blogs__content">
								<p><i class="fal fa-calendar-alt"></i> June 21, 2022</p>
								<h5><Link class="blog-title" to="/news-details">
										Software Makes Your Profit Double if You Scale Properly</Link></h5>
								<p class="text">A great commerce experience cannot be distilled to a single number. It’s
									not a
									Lighthouse score, or a set of...</p>
								<div class="btn-part">
                                <Link to="/news-details" class="readon-arrow">Read More <i class="fa fa fa-arrow-right"></i></Link>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6">
						<div class="blogs mb-30">
							<div class="blogs__thumb">
                                <Link to="/news-details">
									<img class="w-100" src="assets/img/home-5/3-768x409.jpg" alt="Blog Img" />
								</Link>
							</div>
							<div class="blogs__content">
								<p><i class="fal fa-calendar-alt"></i> June 21, 2022</p>
								<h5><Link class="blog-title" to="/news-details">
										Designing Machine Intering For Vehicles Of The Future</Link></h5>
								<p class="text">A great commerce experience cannot be distilled to a single number. It’s
									not a
									Lighthouse score, or a set of...</p>
								<div class="btn-part">
									<Link to="/news-details" class="readon-arrow">Read More <i class="fa fa fa-arrow-right"></i></Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="section-btn">
					<Link to="/news" class="btn">Veiw All Posts</Link>
				</div>
			</div>
		</section>
    )
}